import React from "react";
import styles from "./Loader.module.scss";

const Loader = ({
  fullScreen = false,
  className = "",
}) => {
  const spinner = <div className={`${styles.spinner} ${className}`} />;

  if (fullScreen) {
    return <div className={styles.fullScreenOverlay}>{spinner}</div>;
  }

  return spinner;
};

export default Loader;
